import { gql } from "@apollo/client";

export const UPDATE_VERIFIER_POSITIONS = gql`
  mutation updateVerifierPositions(
    $templateId: String
    $clientIdentifier: String
    $input: TemplateVerifierPositionsInput!
  ) {
    invoiceInterpretation {
      updateVerifierPositions(
        templateId: $templateId
        clientIdentifier: $clientIdentifier
        input: $input
      ) {
        success
      }
    }
  }
`;
